"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignObjective = void 0;
var CampaignObjective;
(function (CampaignObjective) {
    CampaignObjective["OUTCOME_APP_PROMOTION"] = "OUTCOME_APP_PROMOTION";
    CampaignObjective["OUTCOME_AWARENESS"] = "OUTCOME_AWARENESS";
    CampaignObjective["OUTCOME_ENGAGEMENT"] = "OUTCOME_ENGAGEMENT";
    CampaignObjective["OUTCOME_LEADS"] = "OUTCOME_LEADS";
    CampaignObjective["OUTCOME_SALES"] = "OUTCOME_SALES";
    CampaignObjective["OUTCOME_TRAFFIC"] = "OUTCOME_TRAFFIC";
})(CampaignObjective || (exports.CampaignObjective = CampaignObjective = {}));
